export default "/images/0db0d61772b60c4ecf3338d02c5e6424.avif";